(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'emotion', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('emotion'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.emotion, global.styles);
    global.indexCss = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _emotion, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    & .tabber-tab:first-child {\n      margin-left: 0;\n    }\n\n    & .tabber-tab:last-child {\n      margin-right: 0;\n    }\n  '], ['\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    & .tabber-tab:first-child {\n      margin-left: 0;\n    }\n\n    & .tabber-tab:last-child {\n      margin-right: 0;\n    }\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 25%;\n  '], ['\n    width: 25%;\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 33%;\n  '], ['\n    width: 33%;\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 50%;\n  '], ['\n    width: 50%;\n  ']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
      _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin: 0 0.5rem 1rem 0.5rem;\n    border-radius: 3px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n    overflow: hidden;\n    background-color: white;\n    &:hover {\n      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12), 0 8px 8px 0 rgba(0, 0, 0, 0.24);\n    }\n  '], ['\n    margin: 0 0.5rem 1rem 0.5rem;\n    border-radius: 3px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n    overflow: hidden;\n    background-color: white;\n    &:hover {\n      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12), 0 8px 8px 0 rgba(0, 0, 0, 0.24);\n    }\n  ']),
      _templateObject7 = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 4px;\n    background-color: ', ';\n  '], ['\n    height: 4px;\n    background-color: ', ';\n  ']),
      _templateObject8 = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 4px;\n    background-color: ', ';\n    margin: auto;\n    width: 0px;\n    transition: width 0.2s ease;\n  '], ['\n    height: 4px;\n    background-color: ', ';\n    margin: auto;\n    width: 0px;\n    transition: width 0.2s ease;\n  ']),
      _templateObject9 = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 4px;\n    background-color: ', ';\n    margin: auto;\n    width: 100%;\n  '], ['\n    height: 4px;\n    background-color: ', ';\n    margin: auto;\n    width: 100%;\n  ']),
      _templateObject10 = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding: 1rem 1.5rem;\n    display: flex;\n  '], ['\n    padding: 1rem 1.5rem;\n    display: flex;\n  ']),
      _templateObject11 = (0, _taggedTemplateLiteralLoose3.default)([''], ['']),
      _templateObject12 = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin-left: 1rem;\n  '], ['\n    margin-left: 1rem;\n  ']),
      _templateObject13 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    align-items: center;\n  '], ['\n    display: flex;\n    align-items: center;\n  ']),
      _templateObject14 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-family: ', ';\n  '], ['\n    font-family: ', ';\n  ']),
      _templateObject15 = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding-bottom: 0.25rem;\n  '], ['\n    padding-bottom: 0.25rem;\n  ']),
      _templateObject16 = (0, _taggedTemplateLiteralLoose3.default)(['\n    &:hover {\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n    }\n  '], ['\n    &:hover {\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n    }\n  ']),
      _templateObject17 = (0, _taggedTemplateLiteralLoose3.default)(['\n    opacity: 0.2;\n  '], ['\n    opacity: 0.2;\n  ']);

  var prussian = _styles.colors.prussian,
      gold = _styles.colors.gold,
      slate = _styles.colors.slate,
      leaf = _styles.colors.leaf,
      silver = _styles.colors.silver;
  var ProximaNova = _styles.fonts.ProximaNova,
      ProximaNovaSemiBold = _styles.fonts.ProximaNovaSemiBold;


  var styles = {
    tabberWrapper: (0, _emotion.css)(_templateObject),
    fourTab: (0, _emotion.css)(_templateObject2),
    threeTab: (0, _emotion.css)(_templateObject3),
    twoTab: (0, _emotion.css)(_templateObject4),
    oneTab: (0, _emotion.css)(_templateObject5),
    rounded: (0, _emotion.css)(_templateObject6),
    highlighterActive: (0, _emotion.css)(_templateObject7, leaf),
    highlighterInactive: (0, _emotion.css)(_templateObject8, silver),
    highlighterGraybar: (0, _emotion.css)(_templateObject9, silver),
    content: (0, _emotion.css)(_templateObject10),
    icon: (0, _emotion.css)(_templateObject11),
    labelWrapper: (0, _emotion.css)(_templateObject12),
    labelWrapperCenter: (0, _emotion.css)(_templateObject13),
    label: (0, _emotion.css)(_templateObject14, ProximaNovaSemiBold),
    labelSubText: (0, _emotion.css)(_templateObject15),
    lockedNoHover: (0, _emotion.css)(_templateObject16),
    lockedOpacity: (0, _emotion.css)(_templateObject17)
  };

  exports.default = styles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/index.css.js
// module id = 565
// module chunks = 0